import React from 'react';
import { bool, shape, string } from 'prop-types';

const LoadingWorks = ({
  className = '',
  notUseClass = false,
  style = { color: '#9A6412' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.46582 4.91504L9.84766 13.8037C11.2991 13.7894 12.654 14.5727 13.3672 15.8369L21.2168 13.7334L21.7344 15.665L13.8838 17.7686C13.9013 19.5497 12.72 21.1865 10.9199 21.6689C8.78606 22.2407 6.59228 20.9737 6.02051 18.8398C5.53839 17.0398 6.36384 15.1967 7.91504 14.3213L5.83203 6.54688L1.56055 5.40332L2.07812 3.4707L7.46582 4.91504ZM11.8164 17.2871C11.5306 16.2208 10.4345 15.5873 9.36816 15.8721L9.36328 15.873C8.2984 16.1602 7.66683 17.2565 7.95215 18.3223C8.23803 19.3892 9.33541 20.0232 10.4023 19.7373C11.4691 19.4513 12.1023 18.354 11.8164 17.2871Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16.6963 4.5918C17.2298 4.44886 17.778 4.76536 17.9209 5.29883L19.4746 11.0947C19.6172 11.6279 19.3006 12.1763 18.7676 12.3193L14.126 13.5625C13.3816 12.8196 12.4531 12.282 11.4375 12.0088L10.1943 7.36914C10.0514 6.83567 10.3679 6.28747 10.9014 6.14453L16.6963 4.5918ZM12.3848 7.81738L13.0977 10.4805C13.6357 10.717 14.1467 11.0117 14.6201 11.3594L17.2832 10.6455L16.248 6.78223L12.3848 7.81738Z" fill="currentColor" />
  </svg>
);

LoadingWorks.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default LoadingWorks;
